import { useSelector } from "react-redux";
import { RootState } from "../state/store";

const useAuth = () => {
  const { token, business_type, valid } = useSelector((state: RootState) => state.auth);
  const {
    id,
    full_name,
    email,
    membership_type,
    role,
    avatar,
    is_verified_email,
  } = useSelector((state: RootState) => state.user);

  const isLoggedIn = !!token;

  return {
    token,
    business_type,
    valid,
    isLoggedIn,
    id,
    full_name,
    // email,
    membership_type,
    role,
    avatar,
    is_verified_email,
  };
};

export default useAuth;
